/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Student1 } from '../../models/student-1';

export interface ApiStudentByExternalIdExternalIdPatch$Params {
  external_id: string;
      body: Student1
}

export function apiStudentByExternalIdExternalIdPatch(http: HttpClient, rootUrl: string, params: ApiStudentByExternalIdExternalIdPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiStudentByExternalIdExternalIdPatch.PATH, 'patch');
  if (params) {
    rb.path('external_id', params.external_id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiStudentByExternalIdExternalIdPatch.PATH = '/api/student/by-external-id/{external_id}';
